import { openChat } from '../react/features/chat/actions.web';

import KiteNotifications from './modules/KiteNotifications';
import WildixEvents from './service/WildixEvents';

const notifications = new KiteNotifications();

export default class EventManager {

    #eventEmitter;
    #methods;

    /**
     *
     * @param emitter
     * @param methods
     */
    constructor(emitter, methods) {
        this.#eventEmitter = emitter;
        this.#methods = methods;
    }

    /**
     *
     */
    init() {
        notifications.init();
        this.#eventEmitter.on(WildixEvents.CHAT_RECEIVER, this.#onChatReceived);
        window.addEventListener('unload', this.#methods.disposeConference);
        document.addEventListener(WildixEvents.CONFERENCE_JOINED, this.#methods.conferenceLoaded, false);
    }

    /**
     *
     */
    destroy() {
        this.#eventEmitter.off(WildixEvents.CHAT_RECEIVER, this.#onChatReceived);
    }

    /**
     *
     * @param data
     */
    #onChatReceived = data => {
        notifications.show(data.name, {
            icon: data.icon,
            title: data.name,
            body: data.body,
            audio: false
        }, {
            click: () => {
                APP.store.dispatch(openChat());
            }
        });
    }
}
